// TEMP: Question Pool Upgrade — remove after full migration.
import { http } from '../index';

export const getQuestionPoolVersionGroups = (params = {}) => {
  return http
    .get('/moodle/question-pool-upgrade/version-groups', { params })
    .then(res => res.data);
};

export const getQuestionPoolPoolFlags = moodleCourseIds => {
  return http
    .post('/moodle/question-pool-upgrade/pool-flags', { moodleCourseIds })
    .then(res => res.data);
};

export const checkQuestionPoolCourses = moodleCourseIds => {
  return http
    .post('/moodle/question-pool-upgrade/check', { moodleCourseIds })
    .then(res => res.data);
};

export const syncQuestionPoolExports = ({
  moodleCourseId,
  moodleAttemptIds = [],
}) => {
  return http
    .post('/moodle/question-pool-upgrade/sync-exports', {
      moodleCourseId,
      moodleAttemptIds,
    })
    .then(res => res.data);
};

export const upgradeQuestionPoolCourses = (moodleCourseIds, selectCount = 20) => {
  return http
    .post('/moodle/question-pool-upgrade/upgrade', {
      moodleCourseIds,
      selectCount,
    })
    .then(res => res.data);
};
